import {
  clearBannerState,
  clearBattleGroupWin,
  forceBattleGroupWin,
  sendSetHasCompletedOnboardingFalseRequest,
} from '@/network/api';
import { Box, Button, CloseButton, HStack, VStack } from '@chakra-ui/react';
import { useState } from 'react';

export const DevPanel = () => {
  const [open, setOpen] = useState(true);

  if (process.env.VITE_ENABLE_DEV_PANEL !== 'true') return null;

  const startOnboardingFlow = async () => {
    await sendSetHasCompletedOnboardingFalseRequest();
    window.location.reload();
  };

  const resetBanners = async () => {
    await clearBannerState();
    window.location.reload();
  };

  const handleForceBGWin = async () => {
    await forceBattleGroupWin();
    window.location.reload();
  };

  const handleClearBGWin = async () => {
    await clearBattleGroupWin();
    window.location.reload();
  };

  if (!open) return null;
  return (
    <Box position="fixed" zIndex="sticky" bottom={40} right={10} height={130}>
      <HStack w="full" justifyContent="end" mb={2}>
        <CloseButton onClick={() => setOpen(false)} bgColor="bg.muted" borderRadius="full" />
      </HStack>
      <Box bgColor="bg" zIndex={1} p={2} borderRadius="xl" boxShadow="lg">
        <VStack fontSize="xs">
          <Button w="full" onClick={startOnboardingFlow}>
            Start Onboarding Flow
          </Button>
          <Button w="full" onClick={resetBanners}>
            Reset Banners
          </Button>
          <Button w="full" onClick={handleForceBGWin}>
            Force Win BG
          </Button>
          <Button w="full" onClick={handleClearBGWin}>
            Clear Win BG
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};
